import { render, staticRenderFns } from "./viewPhytosanitaryProductProductDetail.vue?vue&type=template&id=20234250&"
import script from "./viewPhytosanitaryProductProductDetail.vue?vue&type=script&lang=js&"
export * from "./viewPhytosanitaryProductProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports